import type {Request} from "express";

export const EXCLUDED_VARIANT = "_excluded";

export const getAbTestVariantFromQuery = (id: string, variants: string[], sampling: boolean, req?: Partial<Request>): string | null => {
    if (req?.query?.ab_test_experiment && req.query.ab_test_experiment === id) {
        const variant = req.query.ab_test_variant as string;

        if (variant) {
            const allowedVariants = sampling ? [...variants, EXCLUDED_VARIANT] : variants;

            return allowedVariants.includes(variant) ? variant : null;
        }
    }

    return null;
};
